export default "__VITE_ASSET__599f7440__"